export default (v: any) => !!v || "Toto pole nesmí být prázdné";
